// JS
import '~/src/custom/js/index';

// Base SCSS
import '~/src/custom/scss/base.scss';
import '~/src/custom/scss/layout.scss';

// Components JS
import '~/src/custom/js/pagebuilder';
import '~/src/custom/js/components/focus-area-cards.js';

// Components SCSS
import '~/src/custom/scss/pagebuilder.scss';
import '~/src/custom/scss/components/sitemap/sitemap.scss';
import '~/src/custom/scss/components/error/not-found.scss';